import React from "react";
import { Box, Typography } from "@mui/material";

interface LocationCardFieldGroupProps {
  title: string;
  children: React.ReactNode;
}

/**
 * A titled panel of `LocationCard.Field`s (e.g. "Pricing"), two fields per row
 * (from `lg` the groups sit beside the photo column, too narrow for four).
 */
const LocationCardFieldGroup = ({ title, children }: LocationCardFieldGroupProps) => (
  <Box component="section" aria-label={title} sx={{ bgcolor: "#f6f8fa", borderRadius: 1, p: "10px 14px", minWidth: 0 }}>
    <Typography
      component="h3"
      sx={{
        fontSize: "0.7143rem", // 10px at 14px root
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.6px",
        color: "#5E7782",
        mb: 0.5,
      }}
    >
      {title}
    </Typography>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        columnGap: 1.5,
      }}
    >
      {children}
    </Box>
  </Box>
);

export default LocationCardFieldGroup;
